<script>
import FooterView from "@/views/FooterView.vue";
import HeaderView from "@/views/HeaderView.vue";
import TopMenu from "@/components/TopMenu.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

export default {
  components: {
    HeaderView,
    TopMenu,
    FooterView,
  },
  setup() {
    const route = useRoute();

    // Nawigacja globalna jest częścią layoutu (jeden pasek na pełną szerokość okna),
    // a nie każdego widoku osobno. Wyjątek: wymuszona zmiana hasła — tam użytkownik
    // nie może nawigować po aplikacji, więc pasek pozostaje ukryty (jak dotychczas).
    const showNavigation = computed(() => route.path !== "/password-expired");

    return { showNavigation };
  },
};
</script>

<template>
  <HeaderView />
  <TopMenu v-if="showNavigation" />
  <slot />
  <FooterView />
</template>
